import { CREATE_USER, RETRIEVE_USER, UPDATE_USER } from "../../actions/types";

const initialState = [];

function userReducer(users = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CREATE_USER:
            return [...users, payload];
        case RETRIEVE_USER:
            return payload;
        case UPDATE_USER:
            return users.map((user) => {
                if (user.email === payload.email) {
                    return {
                        ...user,
                        ...payload,
                    };
                } else {
                    return user;
                }
            });
        default:
            return users;
    }
}

export default userReducer;
